// Check if input exists in text
export const checkIfInputExistsInText = (text, input) =>
  text
    .toLowerCase()
    .indexOf(input.toLowerCase()) > -1

export function isJSON(obj) {
    return typeof obj === "object";
  }
